import { Translation } from 'react-i18next';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import cx from 'clsx';

import { ColumnProps, UserAvatar, UserName, UserCard } from '@/components';
import { formatNum, formatRanking, shortenAddress } from '@/utils';
import { TopTokens } from '@/components/Stats';

import { ProposalVoter } from '../types';
import style from './index.module.scss';

export const getPcColumns = (refetch: () => void): Array<ColumnProps<ProposalVoter>> => [
  {
    title: (
      <span style={{ paddingLeft: 26 }}>
        <Translation>{t => t('DetailContainer_columns.1dbn3c')}</Translation>
      </span>
    ),
    key: 'id',
    width: '18%',
    render: ({ cellData, row }) => {
      return <UserCard data={row.desc} onMemoChange={refetch} />;
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={230} />
      </div>
    ),
  },
  {
    title: <Translation>{t => t('DetailContainer_columns.pp2nez')}</Translation>,
    width: '13%',
    key: 'desc.usd_value',
    render: ({ cellData }) => {
      return <span className={style.tableNetWorth}>{`${formatRanking(cellData)}`}</span>;
    },
    skeleton: <Skeleton width={120} />,
  },
  {
    title: <Translation>{t => t('DetailContainer_columns.lga8rp')}</Translation>,
    width: '23%',
    key: 'top_tokens',
    render: ({ row }) => {
      return (
        <TopTokens
          data={[...(row?.stats?.top_coins || []), ...(row?.stats?.top_tokens || [])]}></TopTokens>
      );
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={104} />
      </div>
    ),
  },
  // {
  //   title: <Translation>{t => t('DetailContainer_columns.9kxv3k')}</Translation>,
  //   width: '23%',
  //   key: 'top_protocols',
  //   render: ({ row }) => {
  //     return <TopProtocols data={row?.stats?.top_protocols || []} />;
  //   },
  //   skeleton: (
  //     <div className={style.innerCell}>
  //       <Skeleton width={104} />
  //     </div>
  //   ),
  // },
  // {
  //   title: <Translation>{t => t('AccountList_columns.top-nft-collections')}</Translation>,
  //   width: '23%',
  //   key: 'top_nfts',
  //   render: ({ row }) => {
  //     return <TopCollections data={row?.stats?.top_collections || []} />;
  //   },
  //   skeleton: (
  //     <div className={style.innerCell}>
  //       <Skeleton width={104} />
  //     </div>
  //   ),
  // },
];

export const getMobileColumns = (userId?: string): Array<ColumnProps<ProposalVoter>> => [
  {
    title: (
      <span style={{ paddingLeft: 26 }}>
        <Translation>{t => t('DetailContainer_columns.1dbn3c')}</Translation>
      </span>
    ),
    key: 'id',
    width: '25%',
    render: ({ cellData, row }) => {
      return (
        <div className={style.mobileUserCard}>
          <UserAvatar className={style.mobileAvatar} data={row.desc} />
          <div>
            <UserName name={row.desc?.user?.web3_id} address={row.id} userDesc={row.desc} />
            <div className={style.mobileUserId}>{shortenAddress(row.id)}</div>
          </div>
        </div>
      );
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={230} />
      </div>
    ),
  },
  {
    title: <Translation>{t => t('DetailContainer_columns.pp2nez')}</Translation>,
    width: '25%',
    key: 'desc.usd_value',
    align: 'right',
    render: ({ cellData, row }) => {
      return (
        <span className={cx(style.tableNetWorth, userId === row.id && style.isSelf)}>
          {`$${formatNum(cellData, 0)}`}
        </span>
      );
    },
    skeleton: <Skeleton width={120} />,
  },
];
